import React, { memo, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { createSelector } from 'reselect';
import { logging, logPostInfo } from '../../actions/log';
import { CONTEXT } from '../../config';
import Button from '../Button/Button';
import styles from './SoftCardGameImg.module.less';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

export default memo(({ soft, logInfo }) => {
  const dispatch = useDispatch();
  const logInfoData = useSelector(selectLogInfo);

  const handleSoftCard = useCallback(
    flag => {
      dispatch(
        logging({
          category: 'C',
          action: 'handle_SoftCard',
          label: '',
          param2: {
            source: logInfo.source,
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            cardName: 'SoftCardGameImg',
          },
          param3: soft.bizInfo,
        }),
      );
      if (flag === 1 && logInfo.tag === 'game' && logInfo.source) {
        // 小banner点击
        dispatch(
          logging({
            category: 'C',
            action: 'Game_Tab_Banner',
            label: '',
            param2: {
              source: logInfo.source,
              source_p: logInfoData.source_p,
              source_pp: logInfoData.source_pp,
            },
            param3: soft.bizInfo,
          }),
        );
      }
      const source = logInfo ? logInfo.source : 'SoftCard_err';
      dispatch(
        logPostInfo({
          source_p: source,
          source_pp: logInfoData.source_p,
          // bizInfo: soft_.bizInfo
        }),
      );
    },
    [dispatch, logInfo],
  );

  return (
    <div className={styles.soft_card}>
      <Link
        className={styles.card_link}
        to={{
          pathname: `${CONTEXT}/detail/soft/${soft.softID || ''}/${soft.bizInfo || '{}'}`,
        }}
        onClick={() => {
          handleSoftCard(1);
        }}
      >
        <img className={styles.card_img} src={soft.ztImg} alt="img" />
      </Link>
      <div className={styles.card_soft}>
        <Link
          className={styles.card_link}
          to={{
            pathname: `${CONTEXT}/detail/soft/${soft.softID || ''}/${soft.bizInfo || '{}'}`,
          }}
          onClick={() => {
            handleSoftCard();
          }}
        >
          <img className={styles.card_soft_logo} src={soft.logoFile} alt="" />
        </Link>
        <div className={styles.card_soft_info}>
          <Link
            className={styles.card_link}
            to={{
              pathname: `${CONTEXT}/detail/soft/${soft.softID || ''}/${soft.bizInfo || '{}'}`,
            }}
            onClick={() => {
              handleSoftCard();
            }}
          >
            <div
              className={styles.card_soft_name}
              title={soft.softName.length > 8 ? soft.softName : ''}
            >
              {soft.softName}
            </div>
          </Link>
          <div className={styles.card_soft_desc}>{soft.downloadCount || 0}安装</div>
        </div>
        <div
          onClick={e => {
            e.stopPropagation();
          }}
        >
          <Button
            soft={soft}
            info={{
              className: styles.card_soft_btn,
              className_busing: styles.card_soft_btn_busing,
              className_open: styles.card_soft_btn_open,
              text: '安装',
            }}
            logInfo={{ ...logInfo }}
          />
        </div>
      </div>
      <div className={styles.card_desc}>{soft.introduction}</div>
    </div>
  );
});
